import {
	resources as memberRolesResources,
	pageAccessResource,
} from '@atlassian/eoc-member-roles/resources';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarEocTeamDashboard, {
	LazyTeamDashboardSidebar,
} from '@atlassian/jira-navigation-apps-sidebar-eoc-team-dashboard/src/async.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@atlassian/jira-operations-horizontal-nav/src/async.tsx';
import { opsTeamLayout } from '@atlassian/jira-ops-team-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { eocPermissionsRoute } from '@atlassian/jira-router-routes-eoc-permissions-routes/src/eocPermissionsRoute.tsx';
import MemberRoles, { LazyMemberRoles } from './ui/spa/eoc/member-roles/index.tsx';

export const eocPermissionsRouteEntry = createEntry(eocPermissionsRoute, () => ({
	group: 'eoc',
	component: MemberRoles,
	layout: opsTeamLayout,

	resources: [
		...getNavigationResources(),
		// pageAccessResource should be defined before memberRolesResources since they depend on it
		pageAccessResource,
		...memberRolesResources(),
		...teamDashboardResources(),
		getConsolidationStateResource(),
	],

	navigation: {
		menuId: MENU_ID.PEOPLE,
		sidebar: AsyncSidebarEocTeamDashboard,
		horizontal: AsyncHorizontalOperationsNav,
		onlyShowHorizontalOnNav4: true,
	},

	forPaint: [
		LazyHorizontalOperationsNav,
		LazyAtlassianNavigation,
		LazyMemberRoles,
		LazyTeamDashboardSidebar,
	],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-eoc-permissions-entries/src/eocPermissionsRouteEntry.tsx',
			whichExportToUse: 'eocPermissionsRouteEntry',
		},

		enabled: true,
	},
}));
